import { fr } from "date-fns/locale";
import image1 from "./../assets/img/timeline/1.jpg";
import image2 from "./../assets/img/timeline/2.jpg";
import image3 from "./../assets/img/timeline/3.jpg";
import image4 from "./../assets/img/timeline/4.jpg";
import image_2014 from "./../assets/img/timeline/image_2014.jpg";
import image_2016 from "./../assets/img/timeline/image_2016.png";
import image_2018_1 from "./../assets/img/timeline/image_2018_1.jpg";
import image_2018_2 from "./../assets/img/timeline/image_2018_2.png";
import image_2020 from "./../assets/img/timeline/image_2020.jpg";
import image_2021 from "./../assets/img/timeline/image_2021.jpg";
import image_2021_2 from "./../assets/img/timeline/image_2021_2.png";
import image_2023 from "./../assets/img/timeline/image_2023.jpg";
import years_old_10 from "./../assets/img/timeline/10_years_old.jpg";
import years_old_16 from "./../assets/img/timeline/16_years_old.jpg";
import years_old_25 from "./../assets/img/timeline/years_old_25.jpg";
import In_2008 from "./../assets/img/timeline/In_2008.jpg";
import In_august from "./../assets/img/timeline/In_august.jpg";
import image_2013 from "./../assets/img/timeline/image_2013.jpg";
import In_2015 from "./../assets/img/timeline/in_2015.png";
import In_2017 from "./../assets/img/timeline/In_2017.png";
import In_2019 from "./../assets/img/timeline/In_2019.jpg";
import In_2023 from "./../assets/img/timeline/In_2023.jpg";



export const timelineData = [
  {
    year: "1989",
    content: "<p>Born and raised in Quincy, Florida.</p>",
    image: image1,
    width: '250px',
  },
  {
    year: "At 13 years old",
    content: "<p>He began repairing computers for people in the town and surrounding areas.</p><p>He became part of the team that built the Net Quincy Telecom system.</p>",
    width: '260px'
  },
  {
    year: "At 17 years old",
    content: "<p>He built a data center and developed his own computer operating system.</p>",
    image: image2,
    width: '192px',
    imageWidth: '128px'
  },
  {
    year: "Mid-2007",
    content: "<p>He developed and created a computer operating system.</p>",
    image: image3,
  },
  {
    year: "In May 2009",
    content: "<p>He applied for a License Spectrum band from the FCC to provide radio telecommunications via the internet and voice.</p>",
    image: image4,
  },
  {
    year: "In 2011",
    content: "<p>The FCC approved Figgers’ application to hold an FCC License Spectrum (permission to a cell phone company).</p>",
  },
  {
    year: "In 2014",
    content: "<p>They developed and released WiMAX (Worldwide Interoperability for Microwave Access).</p>",
    image: image_2014,
  },
  {
    year: "In 2016",
    content: "<p>Figgers Wireless developed the Figgers Hotspot and CPE for home internet. </p><p>Freddie Figgers made Forbes' “30 Under 30.”</p>",
    image: image_2016,
    width: '245px'
  },
  {
    year: "In 2018",
    content: "<p>Figgers Electronics released its first 4K UHD Super Smart TV with three models for specialized environments (residential, commercial, and medical).</p>",
    image: image_2018_1,
    width:'189px'
  },
  {
    year: "In 2018",
    content: "<p>The First Glucometer of Figgers Health was approved and released for advanced patient care, tracking, and reporting.</p>",
    image: image_2018_2,
    width:'189px'
  },
  {
    year: "In 2020",
    content: "<p>An affordable, innovative way to see a doctor.</p><p>Expert care for mental, behavioral, and physical health.</p>",
    image: image_2020,
    width: '210px'
  },
  {
    year: "In 2021",
    content: "<p>Figgers Health developed a central “Electronic Health Record (EHR)” software for any outpatient healthcare organization.</p>",
    image: image_2021,
        width: '200px'
  },
  
 
  {
    year: "In 2022",
    content: "<p>Figgers Communication released a breakthrough in telecommunication technology, revolutionizing the way data is transmitted wirelessly.</p>",
     width: '150px'
  },
  {
    year: "In 2023",
    content: "<p>Figgers Wireless launches a high-speed Home Modem and a versatile Tablet for seamless connectivity and productivity.</p>",
    image: image_2023,
    width: '200px',
    imageWidth: '180px',
  },
  
];

export const timelineDataSecond = [
  {
    year: "At 10 years old",
    content: "<p>He repaired the non-functioning computer bought by his father and made it work.</p>",
    image: years_old_10,
    width:'250px',
  },
  {
    year: "At 16 years old",
    content: "<p>He founded Figgers Communication Inc., a privately held telecommunications company.</p>",
    image: years_old_16,
      width: '260px'
  },
  {
    year: "At 25 years old",
    content: "<p>He designed the Phone Figgers X1, which prevented texting when the car exceeded 10miles/hour. He designed a device for remote patient monitoring and sold it for 2 million dollars to an undisclosed company.</p>",
    image: years_old_25,
    width: '260px',
  },
  {
    year: "In 2008",
    content: "<p>He had over 80 custom software programs designed and purchased by companies.</p><p> He started developing trackers.</p>",
    image: In_2008,
  },
  {
    year: "In August 2010",
    content: "<p>He designed a voice telecommunication network (Voice Over Internet Protocol) that transmits voice to and from the USA from over 80 countries with landline and mobile connections.</p>",
    image: In_august,
  },
  {
    year: "In 2013",
    content: "<p>Construction began on the first wireless towers for Figgers Communications. </p><p>They started providing affordable connectivity and LTE services to rural areas.</p>",
    image: image_2013,
  },
  {
    year: "In 2015",
    content: "<p>Figgers Wireless (a mobile company) launched the FIGGERS X1 with advanced features.</p>",
    image: In_2015,
  },
  {
    year: "In 2017",
    content: "<p>Figgers Wireless released the FIGGERS F2 mobile phone with more features than the F1and a Gorilla Glass protective casing.</p>",
    image: In_2017,
  },
  {
    year: "In 2019",
    content: "<p>Figgers Wireless released the FIGGERS F3, globally unlocked with 5G capabilities, advanced security features, durable construction, and a sleek design. Figgers Wireless released F-BUDS (F-BUDS Pro and F-BUDS Sport) that provide unrivaled comfort, sound quality, durability, and talk time.</p>",
    image: In_2019,
    sizeBig: true,
  },

  {
    year: "In 2021",
    content: "<p>Figgers DragonX (DX): Sleek, innovative smartphone with customizable features, infrared thermometer, facial recognition, dual SIM slots, and high-res cameras for convenience and security.</p>",
    image: image_2021_2,
    width: '300px'
  },
  {
    year: "In 2023",
    content: "<p>Honored to receive Keiser University's 2023 Honoree Choice Award, recognizing our collective impact on the community and education.</p>",
    image: In_2023,
          width: '200px'
  },

 
];

export const sliderDataMobile = [
  {
    year: "1989",
    content: "<p>Born and raised in Quincy, Florida.</p>",
    image: image1,
    width: '250px',
  },
  {
    year: "At 10 years old",
    content: "<p>He repaired the non-functioning computer bought by his father and made it work.</p>",
    image: years_old_10,
    width:'250px',
  },
  {
    year: "At 13 years old",
    content: "<p>He began repairing computers for people in the town and surrounding areas.</p><p>He became part of the team that built the Net Quincy Telecom system.</p>",
    width: '260px'
  },
  {
    year: "At 16 years old",
    content: "<p>He founded Figgers Communication Inc., a privately held telecommunications company.</p>",
    image: years_old_16,
      width: '260px'
  },
  {
    year: "At 17 years old",
    content: "<p>He built a data center and developed his own computer operating system.</p>",
    image: image2,
    width: '192px',
  },
  {
    year: "At 25 years old",
    content: "<p>He designed the Phone Figgers X1, which prevented texting when the car exceeded 10miles/hour. He designed a device for remote patient monitoring and sold it for 2 million dollars to an undisclosed company.</p>",
    image: years_old_25,
    width: '260px',
  },
  {
    year: "Mid-2007",
    content: "<p>He developed and created a computer operating system.</p>",
    image: image3,
  },
  {
    year: "In 2008",
    content: "<p>He had over 80 custom software programs designed and purchased by companies.</p><p> He started developing trackers.</p>",
    image: In_2008,
  },
  {
    year: "In May 2009",
    content: "<p>He applied for a License Spectrum band from the FCC to provide radio telecommunications via the internet and voice.</p>",
    image: image4,
  },
  {
    year: "In August 2010",
    content: "<p>He designed a voice telecommunication network (Voice Over Internet Protocol) that transmits voice to and from the USA from over 80 countries with landline and mobile connections.</p>",
    image: In_august,
  },
  {
    year: "In 2011",
    content: "<p>The FCC approved Figgers’ application to hold an FCC License Spectrum (permission to a cell phone company).</p>",
  },
  {
    year: "In 2013",
    content: "<p>Construction began on the first wireless towers for Figgers Communications. </p><p>They started providing affordable connectivity and LTE services to rural areas.</p>",
    image: image_2013,
  },
  {
    year: "In 2014",
    content: "<p>They developed and released WiMAX (Worldwide Interoperability for Microwave Access).</p>",
    image: image_2014,
  },
  {
    year: "In 2015",
    content: "<p>Figgers Wireless (a mobile company) launched the FIGGERS X1 with advanced features.</p>",
    image: In_2015,
  },
  {
    year: "In 2016",
    content: "<p>Figgers Wireless developed the Figgers Hotspot and CPE for home internet. </p><p>Freddie Figgers made Forbes' “30 Under 30.”</p>",
    image: image_2016,
    width: '245px'
  },
  {
    year: "In 2017",
    content: "<p>Figgers Wireless released the FIGGERS F2 mobile phone with more features than the F1and a Gorilla Glass protective casing.</p>",
    image: In_2017,
  },
  {
    year: "In 2018",
    content: "<p>Figgers Electronics released its first 4K UHD Super Smart TV with three models for specialized environments (residential, commercial, and medical).</p>",
    image: image_2018_1,
    width:'189px'
  },
  {
    year: "In 2018",
    content: "<p>The First Glucometer of Figgers Health was approved and released for advanced patient care, tracking, and reporting.</p>",
      image: image_2018_2,
    width:'189px'
  },
  {
    year: "In 2019",
    content: "<p>Figgers Wireless released the FIGGERS F3, globally unlocked with 5G capabilities, advanced security features, durable construction, and a sleek design. Figgers Wireless released F-BUDS (F-BUDS Pro and F-BUDS Sport) that provide unrivaled comfort, sound quality, durability, and talk time.</p>",
    image: In_2019,
    sizeBig: true,
  },

  {
    year: "In 2020",
    content: "<p>An affordable, innovative way to see a doctor.</p><p>Expert care for mental, behavioral, and physical health.</p>",
    image: image_2020,
    width: '200px'
  },
  {
    year: "In 2021",
    content: "<p>Figgers Health developed a central “Electronic Health Record (EHR)” software for any outpatient healthcare organization.</p>",
    image: image_2021,
        width: '200px'
  },
  {
    year: "In 2021",
    content: "<p>Figgers DragonX (DX): Sleek, innovative smartphone with customizable features, infrared thermometer, facial recognition, dual SIM slots, and high-res cameras for convenience and security.</p>",
    image: image_2021_2,
    width: '300px'
  },
 
  {
    year: "In 2022",
    content: "<p>Figgers Communication released a breakthrough in telecommunication technology, revolutionizing the way data is transmitted wirelessly.</p>",
  },
  {
    year: "In 2023",
    content: "<p>Figgers Wireless introduces Home Modem and Tablet. The Modem delivers high-speed internet for seamless home connectivity, while the Tablet offers versatility on the move.</p><p>Both redefine tech for enhanced productivity and connectivity.</p>",
    image: image_2023,
    width: '630px',
  },
  {
    year: "In 2023",
    content: "<p>Honored to receive the 2023 Honoree Choice Award from Keiser University, a beacon of excellence in education. Reflects collective efforts for positive community impact, shaping a brighter future.</p>",
    image: In_2023,
          width: '560px',
          imageWidth:'115px'
  },

]